import React, { Component } from 'react';

class ProposalServices extends Component {
    constructor(props){
      super(props);
      this.state = {
        selectedIndex:null,
        selectedService:null
      }
      this.handleInputChange = this.handleInputChange.bind(this);
    }


    handleInputChange(e) {
      let updated_service = Object.assign({}, this.state.selectedService);
      updated_service[e.target.name] = e.target.value;
      this.setState({selectedService:updated_service});
    }


    serviceTotal(service){
        if (service.price && service.quantity){
            if (service.preview && service.preview.preview_required){
                return (service.price + service.preview.price) * service.quantity;
            } else {
                return service.price * service.quantity;
            }
        }
        return 0;
    }


  render() {
      if (!this.props.service_list) return <div className="alert alert-danger">No Services</div>;
      const {updateHandler} = this.props;
    return (
    	<React.Fragment>
            <div className="card">
                <h4 className="card-title">Services
                {this.props.for_booking ? <button className="btn btn-success pull-right" onClick={this.props.openQuickView}>Add Services</button> : null}
                </h4>
                <div className="media-list media-list-divided bb-1 border-light">
                {this.props.service_list.map((service, index) =>
                    <div className="media align-items-center p-10" key={index}>
                        <div className="media-body">
                            <h4>{service.name}</h4>
                            <p className="text-muted">{service.description}{service.preview && service.preview.preview_required ? <React.Fragment><br/><span style={{fontSize:10+"px"}} className="">{service.preview.name} - this service required and will be added automatically to your quantity.</span></React.Fragment> : null}</p>
                        </div>
                        <div className="media-right text-right">
                          {this.state.selectedService && this.state.selectedIndex === index ?
                            <form className="form-inline">
                              <div className="">
                                <input type="text" name="price" className="form-control col-sm-3" value={this.state.selectedService.price} onChange={this.handleInputChange}/>
                                <input type="number" name="quantity" className="form-control col-sm-2" value={this.state.selectedService.quantity} onChange={this.handleInputChange}/>
                              </div>
                              <button type="button" className="btn btn-primary" onClick={() => {updateHandler(this.state.selectedService, index);this.setState({selectedService:null, selectedIndex:null})}}>Update</button>
                            </form>
                            :
                            <React.Fragment>
                              <h4 className="text-info">${this.serviceTotal(service)}</h4>
                              <small className="opacity-70">{service.quantity} @ ${service.price}</small>
                            </React.Fragment>
                          }
                        </div>
                        {'for_booking' in service ?
                        <div className="media-right text-right">
                            <a className="media-action hover-danger" onClick={() => this.props.deleteHandler(service)}><i className="ti-close"></i></a>
                        </div>
                        :
                        <div className="media-right text-right">
                          {this.state.selectedService && this.state.selectedIndex === index ?
                            <a className="media-action hover-danger" title="cancel" onClick={() => this.setState({selectedService:null, selectedIndex:null})}><i className="ion-android-cancel"></i></a>
                            :
                            <a className="media-action hover-success" onClick={() => this.setState({selectedService:service, selectedIndex:index})}><i className="fa fa-edit"></i></a>
                          }
                        </div>
                        }
                    </div>
                )}
                </div>
            </div>
            <div className="card">
                <h4 className="card-title">Line Items</h4>
                <div className="media-list media-list-divided bb-1 border-light">
                {this.props.lineitem_list.map((lineitem, index) =>
                    <div className="media align-items-center p-10" key={index}>
                        <div className="media-body">
                            <h4>{lineitem.name}</h4>
                            <p className="text-muted">{lineitem.description}</p>
                        </div>
                        <div className="media-right text-right">
                            <h4 className={lineitem.is_credit ? "text-success" : "text-info"}>{lineitem.is_credit ? <span className="fs-10 mr-20 badge badge-danger">PAID</span> : null}{lineitem.is_credit ? "(-$" + lineitem.total +")" : "$" + lineitem.total}</h4>
                            {lineitem.percentage === 0 ? <small className="opacity-70">{ typeof lineitem.quantity == 'number' ? lineitem.quantity + ' @' : null} ${lineitem.price}</small> : <small className="opacity-70">{lineitem.price}% of services</small>}
                        </div>
                        <div className="media-right text-right">
                            <a className="media-action hover-danger" onClick={() => this.props.deleteHandler(lineitem)}><i className="ti-close"></i></a>
                        </div>
                    </div>
                )}
                </div>
            </div>
            <div className="p-40 text-right">
                <div>
                    <small className="text-uppercase text-muted">Services Total</small>
                    <span className="w-150px d-inline-block fw-400">${this.props.service_total}</span>
                </div>
                <div>
                    <small className="text-uppercase text-muted">Line Item Total</small>
                    <span className="w-150px d-inline-block fw-400">${this.props.lineitem_total}</span>
                </div>
                <hr className="hr-sm w-50 mr-0"/>
                <h4 className="text-uppercase">
                    <strong className="fs-14">Total due</strong>
                    <div className="w-150px d-inline-block text-info">
                        <span className="fw-500 fs-20">${this.props.event_total}</span>
                        <span className="fs-10 fw-300 opacity-70">USD</span>
                    </div>
                </h4>
            </div>
        </React.Fragment>
    )
  }
}

export default ProposalServices;



// WEBPACK FOOTER //
// ./src/components/business/ProposalServices.js